


























































































































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import InvoiceHeader from "../components/InvoiceHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import InvoiceItem from "../components/InvoiceItem.vue";
import InvoiceRow from "../components/InvoiceRow.vue";
import Invoice from "../../../usecases/orders/invoice";
import InvoiceService from "../../../usecases/orders/invoice-service";
import MoveEvent from "../presenters/move-event";
import InvoiceItemModel from "@/usecases/orders/invoice-item";
import { client } from "@/api/request";
import InvoiceApi from "@/api/orders/invoice-api";
import InvoiceStatus from "@/usecases/orders/invoice-status";
import InvoiceStatusTranslater from "@/usecases/orders/invoice-status-translater";
import BankAccountApi from "@/api/orders/bank-account-api";
import BankAccount from "../../../entities/bank-account";
import BankAccountOption from "../presenters/bank-account-option";
import VInputWithDropdown from "../../../common/ui/components/VInputWithDropdown.vue";
import BillingRuleApi from "../../../orders/api/billing-rule-api";
import UnitApi from "@/orders/api/unit-api";
import UnitOption from "../presenters/unit-option";
import SelectOption from "../../../common/ui/presenters/select-option";
import PrintApi from "../../../api/orders/print-api";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import LoadingButton from "@/components/LoadingButton.vue";
import TableCellPreviewBar from "@/ui/order/components/TableCellPreviewBar.vue";
import BillingRule from "@/orders/entities/billing-rule";
import formatDate from "@/helpers/formatDate";
import parseDate from "@/helpers/parseDate";
import { isValid } from "date-fns";

const printApi = new PrintApi(client);
const billingRuleApi = new BillingRuleApi(client);
const bankAccountApi = new BankAccountApi(client);
const invoiceApi = new InvoiceApi(client);
const unitApi = new UnitApi(client);
const service = new InvoiceService(invoiceApi, billingRuleApi);

interface InvoiceItemProp {
  item: InvoiceItemModel;
  unitOptions: SelectOption[];
  expenseCategoryOptions: SelectOption[];
  level: number;
  styleGridColumn: string;
  isFirstItemInLayer: boolean;
  isBasedOnRowsOfEstimate: boolean;
  index: number;
}

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    LoadingButton,
    TextTemplateModal,
    VInputWithDropdown,
    VToolbar,
    InvoiceHeader,
    InvoiceItem,
    InvoiceRow,
    TableCellPreviewBar
  }
})
export default class EditInvoicePage extends Vue {
  @Prop({ required: true }) id!: string;

  textTemplateModalOpen = false;
  fields: HeaderItem[] = [];
  invoice = new Invoice();
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  styleGridColumn: string = "";
  printing: boolean = false;
  previewValue: string = "";
  private previewResizeObserver: ResizeObserver | null = null;
  currentIndex: Set<number> = new Set<number>();
  billingRule: BillingRule = new BillingRule(0, 0, 0);
  billingRuleOriginal: BillingRule = new BillingRule(0, 0, 0);

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      const url = await printApi.getInvoicePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      this.printing = false;
      window.open(url, "請求書印刷");
    } else {
      alert("印刷中です");
    }
  }

  handlePreview(payload: { value: string }) {
    this.previewValue = payload.value;
  }

  mounted() {
    const table = (this.$el as HTMLElement).querySelector(
      ".invoice-table"
    ) as HTMLElement | null;
    const preview = (this.$refs.previewSticky as any) as
      | HTMLElement
      | undefined;
    if (!table || !preview) return;

    const setVar = () => {
      table.style.setProperty(
        "--preview-sticky-height",
        `${preview.offsetHeight}px`
      );
    };
    setVar();

    if (typeof (window as any).ResizeObserver === "function") {
      this.previewResizeObserver = new ResizeObserver(() => setVar());
      this.previewResizeObserver.observe(preview);
    }
  }

  beforeDestroy() {
    if (this.previewResizeObserver) {
      this.previewResizeObserver.disconnect();
      this.previewResizeObserver = null;
    }
  }

  get statusOptions() {
    return InvoiceStatus.all().map(value => ({
      value,
      text: InvoiceStatusTranslater.toJp(value)
    }));
  }

  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  get bankAccountOptions(): string[] {
    return this.accounts.map(a => new BankAccountOption(a).value);
  }

  goListPage() {
    this.$router.push({
      name: "order-invoice"
    });
  }

  status = "";

  async save() {
    this.status = "progressing";
    try {
      await service.save(this.invoice);
      await this.loadInvoice();
      await this.$store.dispatch("getStatusProject");
      await this.$store.dispatch("setProjectEstimateExpenseSummary");
      alert("保存しました。");
    } catch (e) {
      alert("保存に失敗しました。");
    } finally {
      this.status = "";
    }
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(Number(this.id));
    this.goListPage();
    await this.$store.dispatch("getStatusProject");
    await this.$store.dispatch("setProjectEstimateExpenseSummary");
  }

  async calculate() {
    this.invoice = await service.calculate(this.invoice);
  }

  addNewItem() {
    this.invoice.items.push(new InvoiceItemModel());
    this.calculate();
  }

  addNewFiveItems() {
    new Array(5).fill(0).forEach(() => {
      this.invoice.items.push(new InvoiceItemModel());
    });
    this.calculate();
  }

  addNewItemTo(index: number, items: InvoiceItemModel[]) {
    const newInvoiceRow = new InvoiceItemModel();
    if (this.isBasedOnRowsOfEstimate) {
      const discountIds: number[] = this.expenseCategories
        .filter(category => category.name === "値引き")
        .map(category => Number(category.id));
      if (discountIds.length === 0) {
        alert(
          "値引きの経費カテゴリがありません。\n" +
            "経費カテゴリの設定画面に登録してください。"
        );
        return;
      }
      newInvoiceRow.expenseCategoryId = discountIds[0];
    }
    items.splice(index, 0, newInvoiceRow);
    this.calculate();
  }

  removeItem(item: InvoiceItemModel, items: InvoiceItemModel[]) {
    const i = items.findIndex(it => it.id === item.id);
    if (i < 0) return;
    items.splice(i, 1);
    this.calculate();
  }

  removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.invoice.items = [];
    this.calculate();
  }

  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    const grandchildren = e.draggedContext.element.items.reduce(
      (total, item) => total + item.items.length,
      0
    );
    return !(
      (from === "parents" && to === "grandchildren" && children > 0) ||
      (from === "children" && to === "grandchildren" && children > 0) ||
      (from === "parents" && to === "children" && grandchildren > 0)
    );
  }

  dragstart() {
    this.editing = true;
  }

  dragend() {
    this.editing = false;
    this.calculate();
  }

  protected async created() {
    await this.loadInvoice();
    this.loadHeader();
    await this.initExpenseCategories();
    await this.loadBankAccountOptions();
    await this.initUnitList();
    await this.getBillingRule();
  }

  private editing = false;
  private accounts: BankAccount[] = [];

  private async loadInvoice() {
    this.invoice = await service.find(Number(this.id));
  }

  private loadHeader() {
    this.fields = [
      {
        name: "見積項目",
        subs: [
          { name: "大項目", width: "10vw" },
          { name: "中項目", width: "10vw" },
          {
            name: "小項目",
            width: !this.isBasedOnRowsOfEstimate ? "12vw" : "10vw"
          },
          ...(this.isBasedOnRowsOfEstimate
            ? [{ name: "経費カテゴリ", width: "9rem" }]
            : []),
          { name: "数量", width: "5rem" },
          { name: "単位", width: "5rem" },
          { name: "単価", width: "6rem" },
          { name: "見積金額", width: "6rem" },
          { name: "備考", width: "1fr" },
          {
            name: !this.isBasedOnRowsOfEstimate ? "操作" : "値引き",
            width: "4rem"
          }
        ]
      }
    ];
    this.styleGridColumn = this.getWidthsString(this.fields);
  }

  private get isBasedOnRowsOfEstimate(): boolean {
    return this.invoice.basedOnEstimateFlg;
  }

  private async loadBankAccountOptions() {
    if (this.invoice.projectId) {
      this.accounts = await bankAccountApi.ourBankAccounts({
        projectId: this.invoice.projectId
      });
    }
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  private async getBillingRule() {
    this.billingRule = await service.getBillingRule(
      String(this.invoice.projectId)
    );
  }

  private async getBillingRuleOriginal() {
    this.billingRuleOriginal = await billingRuleApi.findByProject(
      String(this.invoice.projectId),
      0,
      true
    );
  }

  addTextToMention(text: string) {
    if (this.invoice.mention) {
      this.invoice.mention += "\n";
    }
    this.invoice.mention += text;
    if (text.length > 0 && this.invoice.mention.length > 100) {
      this.invoice.mention = this.invoice.mention.slice(0, 100);
    }
    this.textTemplateModalOpen = false;
  }

  getWidthsString(header: HeaderItem[]): string {
    const widths: string[] = [];

    header.forEach(item => {
      if (item.subs.length === 0 && item.width) {
        widths.push(item.width);
      } else {
        item.subs.forEach(sub => {
          widths.push(sub.width);
        });
      }
    });

    return widths.join(" ");
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      { id: "", name: "", important: false },
      ...(await getExpenseCategories())
    ];
  }

  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }

  upLevel(
    oldParent: InvoiceItemModel | null,
    newParent: Invoice | null,
    item: InvoiceItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.indexOf(oldParent) + 1, 0, item);
    this.calculate();
  }

  downLevel(
    oldParent: InvoiceItemModel | null,
    newParent: Invoice | null,
    item: InvoiceItemModel | null
  ) {
    if (newParent === null || oldParent === null || item === null) {
      return;
    }

    oldParent.items.splice(oldParent.items.indexOf(item), 1);
    newParent.items.splice(newParent.items.length, 0, item);
    this.calculate();
  }

  resetIndex() {
    this.currentIndex.clear();
    this.currentIndex.add(0);
  }

  getNextIndex(): number {
    const firstElement = this.currentIndex.values().next().value;
    this.currentIndex.clear();
    this.currentIndex.add(firstElement + 1);
    return firstElement;
  }

  getInvoiceItemProp(
    item: InvoiceItemModel,
    level: number,
    index: number
  ): InvoiceItemProp {
    const isFirstItemInLayer = index === 0;

    return {
      item: item,
      unitOptions: this.unitOptions,
      expenseCategoryOptions: this.expenseCategoryOptions,
      level: level,
      styleGridColumn: this.styleGridColumn,
      isFirstItemInLayer: isFirstItemInLayer,
      isBasedOnRowsOfEstimate: this.isBasedOnRowsOfEstimate,
      index: this.getNextIndex()
    };
  }

  async updateDueDate(value: string) {
    let dateOfIssue = parseDate(value);
    if (!isValid(dateOfIssue)) {
      dateOfIssue = new Date();
    }

    await this.getBillingRuleOriginal();
    if (
      this.billingRuleOriginal.getDayOfMonth() == null ||
      this.billingRuleOriginal.getCutoffDate() == null ||
      this.billingRuleOriginal.getMonths() == null
    ) {
      this.invoice.dueDate = "0000-00-00";
      return;
    }

    this.invoice.dueDate = formatDate(this.billingRule.getDueDate(dateOfIssue));
  }

  isNegative(value: number): boolean {
    return value < 0;
  }
}
